export enum PayTypeValueZAF {
    savings = 'savings',
    cheque = 'cheque'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/pay-type-ZAF.enum.ts